import {Cookies} from '../shared/cookies-extended';
import 'regenerator-runtime/runtime';
import 'core-js/stable';

const TimerStatusEnum = Object.freeze({
    TimerRunning: 'TimerRunning',
    TimerFinished: 'TimerFinished',
});

export default class PopUpShowTimer {
    constructor(options) {
        this.extraLongExpiration = options.extraLongExpiration || 365 * 1000;
        this.delayTime = options.delayTime || 5000;
        this.name = options.name;
        this.statusCookie = `${this.name}-Pop-Up-Show-Timer-Cookie`;
        this.promise = null;
        this.resolve = null;
        this.reject = null;
    }

    start() {
        if (!this.promise) {
            this.promise = (this.name) ? this._createTimerPromise() : Promise.reject(new Error('PopUpShowTimer options must contain timer name'));
        }

        return this.promise;
    }

    async _createTimerPromise() {
        const status = await this._getStatusAsync();

        return new Promise((resolve, reject) => {
            this.reject = reject;
            this.resolve = resolve;

            switch (status) {
            case TimerStatusEnum.TimerRunning:
                this._startTimer();
                break;
            case TimerStatusEnum.TimerFinished:
                this._onTimerEnd();
                break;
            default:
                this.reject();
                break;
            }
        });
    }

    _startTimer() {
        setTimeout(() => this._onTimerEnd(), this.delayTime);
    }

    _onTimerEnd() {
        this._setStatus(TimerStatusEnum.TimerFinished);
        this.resolve();
    }

    async _getStatusAsync() {
        return await Cookies.getWithBackupCheckAsync(this.statusCookie) || TimerStatusEnum.TimerRunning;
    }

    _setStatus(value) {
        Cookies.setWithBackupAsync(this.statusCookie, value, {expires: this.extraLongExpiration});
    }
}
